export class RequestPassword {

  constructor(
    public email?: string) {
  }
}
